import React, {useCallback} from 'react'
import styled from 'styled-components'
import {List, Paragraph} from 'common/components'
import {
  DropboxContentPreviewData,
  TemplateDropboxContentPreviewProps,
} from './TemplateDropboxContentPreviewProps'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  box-sizing: border-box;
  padding: 10px 0px;
  gap: 20px;
`

const StyledItem = styled(Paragraph)`
  margin: 0px 20px;
`

const StyledRowSeparation = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${({theme}) => theme.gray_1};
`

export default function TemplateDropboxContentPreview<
  T extends DropboxContentPreviewData
>({
  data,
  color,
  renderHeader,
  renderFooter,
  keyExtractor,
}: TemplateDropboxContentPreviewProps<T>) {
  const renderItem = useCallback(
    (item: T) => (
      <StyledItem color={color} fontSize="m" fontWeight="medium">
        {item.name}
      </StyledItem>
    ),
    [color],
  )

  const renderRowSeparation = useCallback(() => <StyledRowSeparation />, [])

  return (
    <StyledContainer>
      {renderHeader && renderHeader()}
      <List
        data={data}
        numColumns={1}
        renderItem={renderItem}
        renderRowSeparation={renderRowSeparation}
        gap={8}
        keyExtractor={keyExtractor}
      />
      {renderFooter && renderFooter()}
    </StyledContainer>
  )
}
